export { default as SectionTabGroup } from "./SectionTabGroup"
